import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pois as poisApi, poiCategories as catApi } from '@/lib/trackizy';
import { poisActions, withScope } from '@/store';

export default function usePOIs() {
  const dispatch = useDispatch();
  const orgId = useSelector((state) => state.org?.id);
  const userId = useSelector((state) => state.session.user?.id);
  // POIs are per org; the enterprise view has none. Each load is stamped with
  // the scope it started in, so a slow one never lands in a later scope.
  const enterpriseMode = useSelector((state) => state.session.mode === 'enterprise');
  const scopeGen = useSelector((state) => state.session.scopeGen);

  useEffect(() => {
    // Skip fetching until authenticated — avoids 401 noise on login page
    if (!userId || enterpriseMode) return;

    poisApi.list()
      .then((data) => {
        if (Array.isArray(data)) dispatch(withScope(poisActions.refresh(data), scopeGen));
      })
      .catch((err) => console.error('Failed to fetch POIs:', err));

    catApi.list()
      .then((data) => {
        if (Array.isArray(data)) dispatch(withScope(poisActions.refreshCategories(data), scopeGen));
      })
      .catch((err) => console.error('Failed to fetch POI categories:', err));
  }, [dispatch, orgId, userId, enterpriseMode, scopeGen]);
}
